// extracted by mini-css-extract-plugin
export default {"dotActive":"ActvityDot-module_dotActive_ZfWW4L","pulsate":"ActvityDot-module_pulsate_r0As8C","dotInactive":"ActvityDot-module_dotInactive_RsmotC"};